export enum GamMorePosition {
  LEFT_BELOW = 'left-below',
  LEFT_ABOVE = 'left-above',
  RIGHT_BELOW = 'right-below',
  RIGHT_ABOVE = 'right-above',
}
